module.exports = __webpack_public_path__ + "img/short02-57s-preview.db86193f.jpg";